import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RouteDataService } from '@services/route-data/route-data.service';
import { InviteCustomerDialogContentComponent } from './invite-customer-dialog-content/invite-customer-dialog-content.component';

@Component({
  selector: 'app-invite-customer-dialog',
  template: ''
})
export class InviteCustomerDialogComponent implements OnInit {

  constructor(
    public dialog: NgbModal,
    private activatedRoute: ActivatedRoute,
    private routeDataService: RouteDataService,
    private router: Router
  ) {}

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.routeDataService.params = this.activatedRoute.snapshot.params;
      this.openDialog();
    })
  }

  openDialog(): void {
    var customerId = this.activatedRoute.snapshot.params.key;

    const dialogRef = this.dialog.open(InviteCustomerDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.customerId = customerId;

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    });
  }
}